import { Component } from '@angular/core';
import { NavbarComponent } from "../../../../partials/navbar/navbar.component";
import { FooterComponent } from "../../../../partials/footer/footer.component";
import { LanguageService } from '../../../../services/language.service';

@Component({
  selector: 'app-basic-definitions',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './basic-definitions.component.html',
  styleUrl: './basic-definitions.component.css'
})
export class BasicDefinitionsComponent {
  texts:any;
  back: any;

  constructor(private langServ: LanguageService) {
    this.texts = this.langServ.getWebisteTexts().posts.basic_definitions;
    this.back = this.langServ.getWebisteTexts().posts.volver_text;
  }
}
